import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import ReactDOM from 'react-dom';
import { UI_EVENTS } from 'playable/dist/src/constants';
import { createSettingsButtonContainer } from './components/SettingsButton/SettingsButton';
import { createSettingsPopoverContainer } from './components/SettingsPopover/SettingsPopover';
import { ModuleUI } from './components/ModuleUI';
import { defaultTexts } from './useTexts';
export class SettingsModule {
  constructor(dependencies) {
    this.dependencies = dependencies;
    _defineProperty(this, "isFullScreen", false);
    _defineProperty(this, "config", {});
    _defineProperty(this, "dummyContainer", document.createElement('div'));
    _defineProperty(this, "settingsPopover", createSettingsPopoverContainer());
    _defineProperty(this, "settingsButton", createSettingsButtonContainer());
    _defineProperty(this, "initSettings", config => {
      var _config$texts;
      const {
        rootContainer,
        bottomBlock,
        tooltipService,
        eventEmitter
      } = this.dependencies;
      this.config = config;
      rootContainer.appendComponentElement(this.settingsPopover.element);
      bottomBlock.addControl('settings', this.settingsButton.element);
      tooltipService.createReference(this.settingsButton.element, {
        text: ((_config$texts = config.texts) == null ? void 0 : _config$texts.buttonTooltip) || defaultTexts.buttonTooltip
      });
      eventEmitter.on(UI_EVENTS.FULL_SCREEN_STATE_CHANGED, this.handleFullScreenChanged);
      this.render();
    });
    _defineProperty(this, "handleSpeedChange", rate => {
      this.dependencies.engine.setPlaybackRate(rate);
    });
    _defineProperty(this, "handleFullScreenChanged", isFullScreen => {
      this.isFullScreen = isFullScreen;
      this.render();
    });
  }
  getAPI() {
    return {
      initSettings: this.initSettings
    };
  }
  render() {
    this.settingsPopover.updatePosition(this.isFullScreen);
    ReactDOM.render( /*#__PURE__*/React.createElement(ModuleUI, {
      buttonContainer: this.settingsButton.element,
      popoverContainer: this.settingsPopover.element,
      isFullScreen: this.isFullScreen,
      config: this.config,
      onSpeedChange: this.handleSpeedChange
    }), this.dummyContainer);
  }
}
_defineProperty(SettingsModule, "dependencies", ['bottomBlock', 'eventEmitter', 'rootContainer', 'engine', 'tooltipService']);
//# sourceMappingURL=module.js.map